import store from "store";
export default function RedirectUnpaidPublicUsers() {
  const user = store.get("user");
  return (
    (user.institute === "5d679d49c136660a09596d85" ||
      user.instituteId === "5d679d49c136660a09596d85") &&
    user.statusType === "unpaid"
  );
}
